import React, { useCallback, useEffect, useState } from "react";
import { Button, Breadcrumbs, Link, Typography, CircularProgress } from "@material-ui/core";
import { Form, Input, Radio, Checkbox, Table } from "antd";
import dayjs from "dayjs";
import useStyles from "../styles/accountCenterStyle.js";
import useFormStyles from "../styles/formStyle.js";
import { useTranslation } from "../langs/useTranslation";
import { useParams } from "react-router-dom";
import {
  createTerm,
  getTermInfo
} from "@/apis/announcementApi";
import { useHistory } from "react-router-dom";
import SelectCompany from "@/components/SelectCompany";
import moment from "moment";
import { IconTrash } from "@/components/Icon/index.js";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 24
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 24
    }
  }
};
const formTimeItemLayout = {
  labelCol: {
    xs: {
      span: 12
    },
    sm: {
      span: 24
    }
  },
  wrapperCol: {
    xs: {
      span: 12
    },
    sm: {
      span: 24
    }
  }
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 16,
      offset: 8
    }
  }
};

const range = (start, end) => {
  const result = [];
  for (let i = start; i < end; i++) {
    result.push(i);
  }
  return result;
};

const CreateTerm = () => {
  const classes = useStyles();
  const formClassName = useFormStyles();
  const history = useHistory();
  const { t } = useTranslation("devicesGroups");
  const { termId, type } = useParams();
  const [form] = Form.useForm();
  const disabled = type === "view";
  const [loading, setLoading] = useState(false)

  const getInfo = useCallback(async () => {
    const res = await getTermInfo({ id: termId });

    form.setFieldsValue({
      ...res,
      receiverId: res.receivers || [],
    });
  }, [termId, form]);

  const columns = [
    {
      title: t({defaultMessage: '名称'}),
      dataIndex: 'name',
      render: (_, { name }, index) => (
        <Form.Item
          style={{margin: 0}}
          name={[index, 'name']}
          required
          rules={[
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value) {
                  return Promise.reject('必填项需要填写名称');
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          <Input placeholder="请输入名称" disabled={disabled} />
        </Form.Item>
      ),
    },
    {
      title: t({defaultMessage: '必填'}),
      dataIndex: 'required',
      width: 120,
      align: 'center',
      render: (_, { required }, index) => (
        <Form.Item name={[index, 'required']} valuePropName="checked" noStyle>
          <Checkbox disabled={disabled} />
        </Form.Item>
      ),
    },
    {
      title: t({defaultMessage: '操作'}),
      dataIndex: 'action',
      width: 120,
      align: 'center',
      render: (_, __, index) => (
        <div
          onClick={() => {
            if (disabled) return
            const items = form.getFieldValue('checkItems');
            form.setFieldsValue({
              checkItems: items.filter((_, i) => i !== index),
            });
          }}
        >
          <IconTrash 
            size={16} 
            color={disabled?"#d9d9d9":"#f53f3f"}
            style={{cursor: disabled?"not-allowed":"pointer"}} 
          />
        </div>
      ),
    },
  ];

  const onFinish = async values => {
    setLoading(true)
    const params = { ...values };
    const saveFn = createTerm;
    if (termId) {
      params.id = termId;
    }

    if (values.receiverId) {
      params.receiverId = JSON.stringify(
        values.receiverId.map(item => item.receiverId)
      );
    }

    try {
      const res = await saveFn(params);
      if (res) {
        history.push("/announcement?index=1");
      }
    } catch (e) { } 
    finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    if (termId) {
      getInfo();
    }
  }, [getInfo, termId]);

  return (
    <div className={classes.root}>
      <main className={classes.announcementContent}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="inherit" href="/announcement?index=1">
            {t({ defaultMessage: "返回条款列表" })}
          </Link>
          <Typography color="textPrimary">
            {t({ defaultMessage: "新建条款" })}
          </Typography>
        </Breadcrumbs>
        <div className={classes.contentSection}>
          <div>
            <Form
              {...formItemLayout}
              className={formClassName.formContent}
              form={form}
              name="register"
              onFinish={onFinish}
              initialValues={{
                receiverType: 1,
                checkItems: [{
                  name: t({defaultMessage: '我同意上述条款'}),
                  required: false
                }]
              }}
              scrollToFirstError
            >
              <div className={classes.contentTitleSection}>
                <Typography variant="h5">
                  {disabled
                    ? t({ defaultMessage: "查看条款" })
                    : termId
                    ? t({ defaultMessage: "编辑条款" })
                    : t({ defaultMessage: "新建条款" })}
                </Typography>

                <div style={{ display: "flex" }}>
                  <Form.Item
                    {...tailFormItemLayout}
                    style={{ marginBottom: 0, marginRight: 20 }}
                  >
                    <Button
                      variant="contained"
                      type="submit"
                      color="primary"
                      htmlType="submit"
                      disabled={disabled || loading}
                      startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
                    >
                      {t({ defaultMessage: "确认" })}
                    </Button>
                  </Form.Item>
                  <Form.Item
                    {...tailFormItemLayout}
                    style={{ marginBottom: 0 }}
                  >
                    <Button
                      variant="outlined"
                      onClick={() => history.push("/announcement?index=1")}
                    >
                      {t({ defaultMessage: "取消" })}
                    </Button>
                  </Form.Item>
                </div>
              </div>

              <Typography variant="h6" style={{ marginBottom: 8 }}>
                {t({ defaultMessage: "基本信息" })}
              </Typography>

              <Form.Item
                name="name"
                label={t({ defaultMessage: "条款标题" })}
                rules={[
                  {
                    required: true,
                    message: t({ defaultMessage: "条款标题为必填" })
                  },
                  () => ({
                    async validator(_, value) {
                      if (value && value.length > 50) {
                        throw new Error(
                          t({ defaultMessage: "条款标题不得超过30字符" })
                        );
                      }
                    }
                  })
                ]}
              >
                <Input
                  maxLength={30}
                  disabled={disabled}
                  placeholder={t({ defaultMessage: "限制30字以内" })}
                />
              </Form.Item>

              <Form.Item
                name="content"
                label={t({ defaultMessage: "条款内容" })}
                rules={[
                  {
                    required: true,
                    message: t({ defaultMessage: "条款内容为必填" })
                  }
                ]}
              >
                <Input.TextArea
                  rows={6}
                  showCount
                  maxLength={200}
                  disabled={disabled}
                />
              </Form.Item>

              <Form.Item
                name="receiverType"
                label={t({ defaultMessage: "接收对象" })}
                rules={[
                  {
                    required: true,
                    message: t({ defaultMessage: "请选择接收对象" })
                  }
                ]}
              >
                <Radio.Group disabled={disabled}>
                  <Radio value={1}>{t({ defaultMessage: "所有用户" })}</Radio>
                  <Radio value={2}>{t({ defaultMessage: "指定用户" })}</Radio>
                </Radio.Group>
              </Form.Item>

              <Form.Item shouldUpdate noStyle>
                {({ getFieldValue }) => {
                  if (getFieldValue("receiverType") === 2) {
                    return (
                      <Form.Item
                        name="receiverId"
                        rules={[
                          {
                            required: true,
                            message: t({ defaultMessage: "请选择指定用户" })
                          }
                        ]}
                      >
                        <SelectCompany disabled={disabled} />
                      </Form.Item>
                    );
                  }
                }}
              </Form.Item>
              <Form.List name="checkItems">
        {(fields, { add }) => (
          <>
            <Button
              color="primary"
              variant="contained"
              onClick={() => add()}
              style={{ marginBottom: 16 }}
              disabled={disabled}
            >
              {t({defaultMessage: "添加"})}
            </Button>

            <Table
              columns={columns}
              dataSource={fields}
              pagination={false}
              rowKey={(record) => record.key}
              components={{
                body: {
                  row: ({ children, ...props }) => (
                    <tr {...props} style={{height: 64}}>{children}</tr>
                  ),
                },
              }}
            />
          </>
        )}
      </Form.List>

            </Form>
          </div>
        </div>
      </main>
    </div>
  );
};

export default CreateTerm;
